import { Puente, RecursoPuente } from '@api/Puente/Puente';
import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';

class PuenteController {
    getPuente = async (recurso: RecursoPuente, id: string): Promise<Puente> => {
        const response = await axiosPrivate.get(`/puente/${recurso}/${encodeURIComponent(id)}`);
        return response.data as Puente;
    };
}

export default PuenteController;
